'use client';

import { c as _c } from "react/compiler-runtime";
import Clarity from '@microsoft/clarity';
import { useEffect } from 'react';
export default function MsClarity() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  if (globalThis.window === undefined || !process.env.NEXT_PUBLIC_CLARITY_ID) {
    return;
  }
  let cancelled = false;
  const initClarity = () => {
    if (cancelled) {
      return;
    }
    Clarity.init(process.env.NEXT_PUBLIC_CLARITY_ID);
  };
  const scheduleInit = () => {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(initClarity, {
        timeout: 2000
      });
      return;
    }
    globalThis.setTimeout(initClarity, 1500);
  };
  if (document.readyState === "complete") {
    scheduleInit();
  } else {
    window.addEventListener("load", scheduleInit, {
      once: true
    });
  }
  return () => {
    cancelled = true;
  };
}